import {
  PiArrowUpDuotone,
  PiBrainDuotone,
  PiChatDuotone,
  PiChatsDuotone,
  PiCheckSquareDuotone,
  PiCodeDuotone,
  PiMapTrifoldDuotone,
  PiPencilSimpleDuotone,
  PiQuestionDuotone,
  PiUsersThreeDuotone,
  PiWrenchDuotone,
} from "react-icons/pi";
import { useQuery } from "react-query";
import { supabase } from "../../../supabaseClient";

export default function CotrStats() {
  async function getTotalRowCount(tableName: string): Promise<number> {
    const { count } = await supabase
      .from(tableName)
      .select("*", { count: "exact", head: true });

    return count ?? 0;
  }

  const {
    data: totalTasks,
    error: tasksError,
    isLoading: loadingTasks,
  } = useQuery("stats-tasks", async () => {
    const response = await getTotalRowCount("tasks");

    return response;
  });

  // users
  const {
    data: totalUsers,
    error: userError,
    isLoading: loadingUsers,
  } = useQuery("stats-users", async () => {
    const response = await getTotalRowCount("users");

    return response;
  });

  return (
    <div className="stats w-full">
      <div className="stat">
        <div className="stat-figure text-secondary ">
          <PiCodeDuotone size={40} />
        </div>
        <div className="stat-title">Code Snippets</div>
        {!loadingTasks && <div className="stat-value">{totalTasks}</div>}
        {loadingTasks && (
          <div className="stat-value loading loading-spinner">...</div>
        )}
        <div className="stat-desc">Since Apr 11, 2024</div>
      </div>
      {/* <div className="stat">
        <div className="stat-figure text-secondary">
          <PiChatDuotone size={40} />
        </div>
        <div className="stat-title">Messages</div>
        {!loadingVotes && <div className="stat-value">{totalMessages}</div>}
        {loadingVotes && (
          <div className="stat-value loading loading-spinner">...</div>
        )}
        <div className="stat-desc">Since Apr 11, 2024</div>
      </div> */}
      {/* <div className="stat">
        <div className="stat-figure text-secondary">
          <PiChatsDuotone size={40} />
        </div>
        <div className="stat-title">Chats</div>
        {!loadingChats && <div className="stat-value">{totalChats}</div>}
        {loadingChats && (
          <div className="stat-value loading loading-spinner">...</div>
        )}
        <div className="stat-desc">Since Apr 11, 2024</div>
      </div> */}

      {/* <div className="stat">
        <div className="stat-figure text-secondary">
          <PiPencilSimpleDuotone size={40} />
        </div>
        <div className="stat-title">Edits</div>
        {!loadingEdits && <div className="stat-value">{totalEdits}</div>}
        {loadingEdits && (
          <div className="stat-value loading loading-spinner">...</div>
        )}
        <div className="stat-desc">Since Apr 11, 2024</div>
      </div> */}
      <div className="stat">
        <div className="stat-figure text-secondary">
          <PiUsersThreeDuotone size={40} />
        </div>
        <div className="stat-title">Community</div>
        {!loadingUsers && <div className="stat-value">{totalUsers}</div>}
        {loadingUsers && (
          <div className="stat-value loading loading-spinner">...</div>
        )}
        <div className="stat-desc">Since Apr 11, 2024</div>
      </div>
    </div>
  );
}
